import { COUNTRIES } from 'shared-constants'
import { type SelectOptionType } from 'components/Select'
import { type Country } from 'types/graphql-generated'

export const COUNTRY_OPTIONS: SelectOptionType<Country>[] = COUNTRIES.map(
  (country) => ({
    label: country.title,
    value: country,
  })
)

export const EMPTY_COUNTRY_OPTION = {
  label: 'Select Country',
  value: { isoCode: null, title: null },
}
